/* Category size presentation only. Does not change the theme's native
   open/close state, variant selection, product forms, or add-to-cart code.
   We position only the existing inner fieldset. The outer wrapper's old
   inline coordinates are not overwritten or used for mobile clipping. No page-scroll listener or network calls. */
(function () {
  'use strict';
  if (window.__platinCategorySizes) return;
  window.__platinCategorySizes = true;

  var scope = '[data-platin-collection-loop]';
  var selector = scope + ' .product-card .product-grid-options-size';
  var mobile = window.matchMedia('(max-width: 767px)');
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var states = new Map();
  var pending = new Set();
  var frame = 0;

  function setVariable(element, name, value) {
    if (element.style.getPropertyValue(name) !== value) element.style.setProperty(name, value);
  }
  function schedule(state) {
    if (state) pending.add(state);
    else states.forEach(function (item) { pending.add(item); });
    if (frame) return;
    frame = requestAnimationFrame(function () {
      frame = 0;
      var batch = Array.from(pending);
      pending.clear();
      batch.forEach(function (item) { if (item.rail.isConnected) layout(item); });
    });
  }
  function updateArrow(state) {
    var he = (document.documentElement.lang || '').toLowerCase().indexOf('he') === 0;
    if (!mobile.matches) {
      var expanded = state.fieldset.hasAttribute('data-pcs-expanded');
      state.button.dataset.direction = expanded ? 'up' : 'down';
      state.button.setAttribute('aria-expanded', String(expanded));
      state.button.setAttribute('aria-label', he
        ? (expanded ? 'צמצום רשימת המידות' : 'הצגת כל המידות')
        : (expanded ? 'Collapse sizes' : 'Show all sizes'));
      return;
    }
    state.button.removeAttribute('aria-expanded');
    var end = Math.max(0, state.form.scrollHeight - state.form.clientHeight);
    var atEnd = end > 1 && state.form.scrollTop >= end - 1;
    state.button.dataset.direction = atEnd ? 'up' : 'down';
    state.button.setAttribute('aria-label', he
      ? (atEnd ? 'חזרה למידות הראשונות' : 'הצגת מידות נוספות')
      : (atEnd ? 'Back to first sizes' : 'Show more sizes'));
  }
  function layout(state) {
    var rail = state.rail;
    var rows = Array.from(state.form.querySelectorAll('.altli')).filter(function (row) {
      return !row.hidden && !row.hasAttribute('disabled') &&
        row.style.display !== 'none' && getComputedStyle(row).display !== 'none';
    });
    var signature = rows.map(function (row) {
      var value = row.querySelector('.size-val');
      return value ? value.getAttribute('value') : '';
    }).join('|');
    if (signature !== state.signature) {
      state.form.scrollTop = 0;
      state.fieldset.removeAttribute('data-pcs-expanded');
      state.signature = signature;
    }
    if (mobile.matches) state.fieldset.removeAttribute('data-pcs-expanded');
    rail.toggleAttribute('data-pcs-empty', !rows.length);
    state.button.hidden = rows.length <= (mobile.matches ? 3 : 6);
    if (mobile.matches && rows.length > 3) state.form.setAttribute('tabindex', '0');
    else if (state.tabindex === null) state.form.removeAttribute('tabindex');
    else state.form.setAttribute('tabindex', state.tabindex);

    if (mobile.matches) {
      var figureRect = state.figure.getBoundingClientRect();
      var parent = state.fieldset.offsetParent;
      if (parent && figureRect.height > 0) {
        var parentRect = parent.getBoundingClientRect();
        var scaleY = parentRect.height / (parent.offsetHeight || parentRect.height) || 1;
        var scaleX = parentRect.width / (parent.offsetWidth || parentRect.width) || 1;
        var panelHeight = Math.min(3, rows.length) * 24 + (rows.length > 3 ? 24 : 0);
        var panelTop = (figureRect.top + figureRect.height / 2 - parentRect.top) / scaleY
          - parent.clientTop + parent.scrollTop - panelHeight / 2;
        var panelRight = (parentRect.right - figureRect.right) / scaleX - parent.clientLeft;
        setVariable(state.fieldset, '--pcs-panel-top', panelTop.toFixed(3) + 'px');
        setVariable(state.fieldset, '--pcs-panel-right', Math.max(0, panelRight).toFixed(3) + 'px');
      }
    }
    updateArrow(state);
  }
  function init(rail) {
    if (states.has(rail)) return;
    var card = rail.closest('.product-card');
    var figure = card && card.querySelector('.product-card__figure');
    var fieldset = rail.querySelector('fieldset');
    var form = fieldset && fieldset.querySelector('form');
    if (!figure || !form) return;
    rail.setAttribute('data-pcs', '1');
    if (getComputedStyle(rail).getPropertyValue('--pcs-styles-ready').trim() !== '1') {
      rail.removeAttribute('data-pcs');
      return; // Missing new CSS: leave the original size picker untouched.
    }
    var button = fieldset.querySelector('.pcs-more') || document.createElement('button');
    button.type = 'button';
    button.className = 'pcs-more';
    button.hidden = true;
    button.innerHTML = '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true" focusable="false"><path d="M2 4 6 8 10 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    fieldset.appendChild(button); // Sibling, never a submit control inside the product form.
    var state = { rail: rail, figure: figure, fieldset: fieldset, form: form,
      button: button, signature: '', tabindex: form.getAttribute('tabindex') };
    states.set(rail, state);
    form.addEventListener('scroll', function () { updateArrow(state); }, { passive: true });
    button.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (button.hidden) return;
      if (!mobile.matches) {
        state.fieldset.toggleAttribute('data-pcs-expanded');
        form.scrollTop = 0;
        updateArrow(state);
        return;
      }
      var end = Math.max(0, form.scrollHeight - form.clientHeight);
      var next = form.scrollTop >= end - 1 ? 0 : Math.min(end, form.scrollTop + 24);
      form.scrollTo({ top: next, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
    });
    state.rowsObserver = new MutationObserver(function (records) {
      if (records.some(function (record) {
        return record.type === 'childList' || (record.target.matches && record.target.matches('.altli'));
      })) schedule(state);
    });
    state.rowsObserver.observe(form, { childList: true, subtree: true, attributes: true,
      attributeFilter: ['style', 'class', 'hidden', 'disabled'] });
    /* Recheck after native layout passes, without rewriting their properties. */
    state.geometryObserver = new MutationObserver(function () {
      var signature = ['top', 'height', 'max-height'].map(function (name) {
        return rail.style.getPropertyValue(name);
      }).join('|');
      if (signature !== state.geometrySignature) {
        state.geometrySignature = signature;
        schedule(state);
      }
    });
    state.geometryObserver.observe(rail, { attributes: true, attributeFilter: ['style'] });
    if (window.ResizeObserver) {
      state.resizeObserver = new ResizeObserver(function () { schedule(state); });
      state.resizeObserver.observe(figure);
      state.resizeObserver.observe(rail);
    }
    layout(state);
  }
  function discover(root) {
    if (!root || !root.querySelectorAll) return;
    if (root.matches && root.matches(selector)) init(root);
    root.querySelectorAll(selector).forEach(init);
  }
  function cleanDetached() {
    states.forEach(function (state, rail) {
      if (rail.isConnected) return;
      state.rowsObserver.disconnect();
      state.geometryObserver.disconnect();
      if (state.resizeObserver) state.resizeObserver.disconnect();
      pending.delete(state);
      states.delete(rail);
    });
  }
  function start() {
    discover(document);
    new MutationObserver(function (records) {
      var removed = false;
      records.forEach(function (record) {
        record.addedNodes.forEach(function (node) { if (node.nodeType === 1) discover(node); });
        if (record.removedNodes.length) removed = true;
      });
      if (removed) cleanDetached();
    }).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('resize', function () { schedule(); }, { passive: true });
    window.addEventListener('load', function () { discover(document); schedule(); });
    window.addEventListener('pageshow', function () { discover(document); schedule(); });
    document.addEventListener('shopify:section:load', function (event) { discover(event.target); schedule(); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { schedule(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
}());
